import React from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/free-solid-svg-icons/faTimes'
import { Input } from '../core/input'
import * as Content from '../Content'

const CONTAINER_STYLES = 'flex flex-col box-border m-0'
const FACETS_CONTAINER_STYLES = 'flex flex-row flex-wrap box-border m-0'
const ICON_CONTAINER_STYLES = 'my-auto ml-2 box-border m-0'

interface IFacet {
  id: string
  value: string
  name?: string // Optional property to support enhanced facets
}

export interface ISearchControlsProps {
  facets?: IFacet[]
  onRemoveFacet: (id: string) => void
  queryString: string
  onQuery: (value: string) => void
}

export const SearchControls: React.FC<ISearchControlsProps> = ({
  facets,
  onRemoveFacet: handleRemoveFacet,
  queryString,
  onQuery: handleQuery,
}) => {
  const handleTextChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    handleQuery(e.currentTarget.value)
  }
  const handleClearFilter = (id: string) => (e: React.MouseEvent) => {
    handleRemoveFacet(id)
  }

  // Format facet display value - if name is provided, show "name: value"
  const getDisplayValue = (facet: IFacet) => {
    if (facet.name && facet.value) {
      return `${facet.name}: ${facet.value}`
    }
    return facet.value
  }

  return (
    <div className={CONTAINER_STYLES}>
      <Input
        placeholder="Search keywords, name"
        value={queryString}
        onChange={handleTextChange}
        name="search"
      />
      {facets ? (
        <div className="mt-2">
          {facets.length > 0 ? <Content.Text>Filters:</Content.Text> : null}
          <div className={FACETS_CONTAINER_STYLES}>
            {facets.map((f) => (
              <button
                className="mt-2 mr-2"
                key={f.id}
                onClick={handleClearFilter(f.id)}
              >
                <Content.Bubble>
                  {getDisplayValue(f)}
                  <div className={ICON_CONTAINER_STYLES}>
                    <FontAwesomeIcon icon={faTimes} />
                  </div>
                </Content.Bubble>
              </button>
            ))}
          </div>
        </div>
      ) : null}
    </div>
  )
}
